import React from 'react';
import OrderDetailContainer from '@src/containers/OrderDetail';
import PermissionGate from '@src/components/PermissionGate';
import { PERMISSIONS } from '@src/constants';

const OrderDetail = () => (
  <PermissionGate
    requiredPermissions={[
      PERMISSIONS.VIEW_ORDER,
      PERMISSIONS.EDIT_ORDER,
      PERMISSIONS.CREATE_ORDER,
      PERMISSIONS.DELETE_ORDER,
    ]}
  >
    <OrderDetailContainer />;
  </PermissionGate>
);

export default OrderDetail;
